import React from "react"

import { Selector, ItemBlockPart } from "@tenforce/toolbox-selector-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { useAppSelector, useAppDispatch } from "../../../hooks"
import { GlobalState } from "../../../store"
import { Labels } from "../../../util/Translations"

import { setVisibility } from "../../flowpanel/slice"
import * as FlowPanelSelectors from "../../flowpanel/selectors"

export const FlowPanelSwitch = (): JSX.Element => {
    const dispatch = useAppDispatch()

    const shouldShowFlowPanelSwitch = useAppSelector(
        (state: GlobalState) => state.resourceHeader.shouldShowFlowPanelSwitch,
    )

    const { isVisible } = useAppSelector(
        (state: GlobalState) => state.flowPanel,
    )

    const isFlowPanelDataAvailable = useAppSelector((state: GlobalState) =>
        FlowPanelSelectors.isFlowPanelDataAvailable(state.flowPanel),
    )

    // hide the flow panel switch if it's not meant to be visible
    // or the data is not available for it
    if (!shouldShowFlowPanelSwitch || !isFlowPanelDataAvailable) {
        return <></>
    }

    return (
        <Selector
            isRequired={false}
            isExpanded={true}
            isSingleSelect={true}
            isWrapped={false}
            data-ft-is-panel-shown={isVisible}
        >
            <ItemBlockPart
                isSelected={isVisible}
                data-ft-component="flowPanelSwitch"
                data-ft-value={isVisible}
                title={Labels.FlowPanelSwitchTooltip}
                onSelected={(): void => {
                    dispatch(setVisibility(true))
                }}
                onUnselected={(): void => {
                    dispatch(setVisibility(false))
                }}
            >
                {Symbols.Process}
            </ItemBlockPart>
        </Selector>
    )
}

export default FlowPanelSwitch
